module.exports = __webpack_public_path__ + "static/media/icon-next-arrow.5e71de52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-next-arrow.svg
// module id = 680
// module chunks = 0